import { motion } from "framer-motion";
import { PILLARS, IMG } from "@/lib/platform";

export default function Positioning() {
  return (
    <section id="about" data-testid="positioning-section" className="relative bg-[#07152B] text-[#F5EBD9] py-24 lg:py-36 overflow-hidden">
      {/* faint architecture backdrop */}
      <div
        className="absolute inset-0 opacity-[0.06] bg-cover bg-center pointer-events-none"
        style={{ backgroundImage: `url(${IMG.arch1})` }}
      />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9 }}
        >
          <div className="font-mono text-[11px] uppercase tracking-[0.32em] text-[#F5892E] mb-4 flex items-center gap-4">
            <span className="h-px w-10 bg-[#F5892E]" />
            Защо съществуваме
          </div>
          <h2 className="font-display uppercase text-4xl sm:text-6xl lg:text-8xl leading-[0.95] tracking-tight">
            Имотите не са късмет.<br />
            <span className="text-[#F5892E]">Те са информация.</span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9, delay: 0.15 }}
          className="mt-10 lg:mt-14 max-w-[68ch] text-lg text-[#C8D4E6] leading-relaxed space-y-5"
        >
          <p>
            „Играта на имотите" е мястото, където инвестициите, реалните данни и хората с опит се
            срещат на една сцена.
          </p>
          <p>
            Тук говорим за пазара без излишен шум. Разглеждаме тенденциите, анализираме числата,
            обсъждаме реални стратегии и задаваме въпросите, които интересуват всеки купувач и
            инвеститор.
          </p>
          <p>
            Нашата мисия е да организираме най-добрите имотни събития в България — събития, които
            дават реална стойност, нови контакти и по-добра перспектива за пазара.
          </p>
        </motion.div>

        {/* Three pillars — editorial rows, not icon boxes */}
        <div className="mt-16 lg:mt-24 border-t border-[#1E3A63]">
          {PILLARS.map((p, i) => (
            <motion.div
              key={p.num}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.8, delay: i * 0.1 }}
              data-testid={`pillar-${p.num}`}
              className="group grid grid-cols-12 gap-4 lg:gap-8 py-8 lg:py-12 border-b border-[#1E3A63] items-baseline hover:bg-[#0F284B]/40 transition-colors duration-500 px-2 sm:px-4"
            >
              <div className="col-span-2 lg:col-span-1 font-mono text-sm text-[#F5892E] tracking-widest">
                {p.num}
              </div>
              <h3 className="col-span-10 lg:col-span-5 font-display uppercase text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-tight group-hover:text-[#F5892E] transition-colors duration-500">
                {p.title}
              </h3>
              <p className="col-span-12 lg:col-span-6 text-[#C8D4E6] leading-relaxed lg:text-lg">
                {p.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
